import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchOutlined } from '@ant-design/icons';
import axios from 'axios';
import { Button, Table, Tag, Modal, Layout, Input } from 'antd';
import AddCousultant from './AddConsultant';
import AddTeam from './AddTeam';
import UpdateTeam from './UpdateTeam';
import AddDebtor from './AddDebtor';
import { useMsal } from '@azure/msal-react';
import AppHeader from '../Component/Header';
import AppMenu from '../Component/Menu';
import { scoutChatCenterServerUrl } from '../autoConfig';
const { Sider, Content } = Layout;

const Chat = () => {
  const [name, setName] = useState('');
  const [collapsed, setCollapsed] = useState(true);
  const navigate = useNavigate();
  const [data, setData] = useState([
    {
      key: '',
      email: '',
      name: '',
      region: '',
      office: '',
      role: ''
    }
  ]);
  const { instance } = useMsal();
  const signOut = async () => {
    try {
      await axios({
        method: 'get',
        url: `${scoutChatCenterServerUrl}/chatSession/removeSSE?consultantEmail=${name}`
      });
    } catch (error) {
      console.log('error occurred fetching bot response', error);
    }
    localStorage.removeItem('username');
    instance.logout();
    window.location.href = '/';
  };
  const onClick = (e) => {
    if (e.key === '1') {
      window.location.href = '/chat';
    }
    if (e.key === '2') {
      window.location.href = '/team';
    }
    if (e.key === '3') {
      navigate('/history');
      //   window.location.href = '/team';
    }
  };
  const [consultantData, setConsultantData] = useState(null);
  const [type, setType] = useState('');
  const [role, setRole] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = (type) => {
    setType(type);
    setIsModalOpen(true);
  };
  const [allTeams, setAllTeams] = useState([]);
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const getAllConsultant = async () => {
    try {
      const response = await axios({
        method: 'get',
        url: `${scoutChatCenterServerUrl}/admin/getConsultantsForAdmin/${name}`
      });
      const transformedData = response.data
        .map((item) => ({
          ...item,
          key: item.email,
          teamName: item.teams.map((ele) => ele.teamName)
        }))
        .sort((a, b) => a.teams.length - b.teams.length);

      return transformedData || [];
    } catch (error) {
      console.log('error occurred fetching bot response', error);
      return [];
    }
  };
  const [searchText, setSearchText] = useState('');
  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      value.toString().toLowerCase().includes(searchText.toLowerCase())
    )
  );
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      filters: [],
      onFilter: (value, record) => record.name.indexOf(value) === 0,
      render: (text) => <a>{text}</a>
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      filters: [
        {
          text: 'offline',
          value: 'offline'
        },
        {
          text: 'online',
          value: 'online'
        }
      ],
      onFilter: (value, record) => record.status.includes(value),
      render: (_, { status }) => (
        <>
          <Tag color={status === 'online' ? 'green' : '#FFBF00'}>{status}</Tag>
        </>
      )
    },
    {
      title: 'email',
      dataIndex: 'email',
      key: 'email'
    },
    {
      title: 'Office',
      dataIndex: 'office',
      key: 'office'
    },
    {
      title: 'Region',
      dataIndex: 'region',
      key: 'region'
    },
    {
      title: 'Country',
      dataIndex: 'country',
      key: 'country'
    },
    {
      title: 'Team',
      dataIndex: 'teamName',
      key: 'teamName',
      filters: allTeams.map((team) => ({ text: team, value: team })),
      onFilter: (value, record) => record.teamName.includes(value),
      render: (_, { teamName }) => (
        <>
          {teamName?.map((item, key) => (
            <Tag key={key}>{item}</Tag>
          ))}
        </>
      )
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <div>
          <Button
            type="link"
            onClick={() => {
              showModal('updateConsultant');
              setConsultantData(record);
            }}
          >
            Edit
          </Button>
          <Button
            type="link"
            danger
            onClick={async () => {
              try {
                const response = await axios({
                  method: 'delete',
                  url: `${scoutChatCenterServerUrl}/consultant/removeConsultant/${record.email}`
                });
                if (response) {
                  window.location.reload();
                }
                return response;
              } catch (error) {
                return [];
              }
            }}
          >
            Remove
          </Button>
        </div>
      )
    }
  ];
  useEffect(() => {
    localStorage.getItem('username') &&
      setName(JSON.parse(localStorage.getItem('username'))[0].value);
    sessionStorage.getItem('role') && setRole(sessionStorage.getItem('role'));
  }, []);
  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const newOptions = await getAllConsultant();
        setData(newOptions);

        // Generate a list of all unique team names
        const allTeamNames = Array.from(
          new Set(newOptions.flatMap((item) => item.teamName))
        );
        setAllTeams(allTeamNames);
      } catch (error) {
        console.error('Failed to fetch options', error);
      }
    };

    name && fetchOptions();
  }, [name]);

  return (
    <Layout>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="demo-logo-vertical" />
        <AppMenu activeKey={'2'} onClick={onClick} role={role} />
      </Sider>
      <Layout>
        <AppHeader
          name={name}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          signOut={signOut}
        />
        <Content className="h-[calc(100vh-64px)] flex">
          <div className="bg-white w-full m-8 ">
            <div className="flex">
              <div className="m-2">
                <Button onClick={() => showModal('addConsultant')}>
                  Add Consultant
                </Button>
              </div>
              <div className="m-2">
                <Button onClick={() => showModal('addTeam')}>Add Team</Button>
              </div>
              <div className="m-2">
                <Button onClick={() => showModal('updateTeam')}>
                  Update Team
                </Button>
              </div>
              <div className="m-2">
                <Button onClick={() => showModal('addDebtor')}>
                  Add Debtor
                </Button>
              </div>
            </div>
            <div className="m-4 w-64 flex">
              <SearchOutlined className="mr-2" />
              <Input
                placeholder="Search"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>

            <Table columns={columns} dataSource={filteredData} />
          </div>

          <Modal
            title={type}
            open={isModalOpen}
            onCancel={handleCancel}
            footer={null}
            maskClosable={false}
          >
            {type === 'addConsultant' ? <AddCousultant /> : null}
            {type === 'updateConsultant' ? (
              <AddCousultant consultantData={consultantData} />
            ) : null}
            {type === 'addTeam' ? <AddTeam /> : null}
            {type === 'updateTeam' ? <UpdateTeam /> : null}
            {type === 'addDebtor' ? <AddDebtor /> : null}
          </Modal>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Chat;
